module.exports = __webpack_public_path__ + "static/logo-strass-709c361ccd22ce2f0727caf14f059404.png";